export const dealTypes = [
  'Affordable Rental Housing: 4%, 9%',
  'Homeownership',
  'Market Rate Multifamily',
  'Mixed Use',
  'Existing Operating Property',
  'Other',
];

export const constructionTypes = ['New Construction', 'Historic Renovation', 'Renovation', 'Adaptive Reuse', 'In-Place Renovation'];

export const acquisitionTypes = ['Off-Market', 'On-Market', 'Joint venture with land owner', 'Other'];

export const siteControlStatuses = [
  'LOI Obtained',
  'Purchase Contract Executed',
  'RFP Submitted',
  'Exclusive Negotiating Period Entered Into',
  'Other',
];

export const projectByRight = ['Yes', 'No', 'Not Yet Determined'];
